import { ModuleBase } from '@/components';
import ReportModulHeader from '@/components/report/ReportModulHeader';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import { useTranslations } from 'next-intl';

type TrendEvolutionModuleModel = ModuleBaseModel<
  {
    future: string;
    futureLabel: string;
    headingLabel: string;
    past: string;
    pastLabel: string;
    present: string;
    presentLabel: string;
  } & ModuleBasePropsModel
>;

const TrendEvolutionModule = (data: TrendEvolutionModuleModel) => {
  const {
    props: { future, past, present },
  } = data;

  const t = useTranslations();

  return (
    <ModuleBase data={{ ...data, props: { anchor: 'report-trend-evolution', ...data.props } }}>
      <ReportModulHeader
        expanded
        title={t('trendEvolution.$heading')}
        className="container print:hidden"
        saveOpenStateKey="trendEvolutionModule"
      >
        <div className="flex flex-col px-0 pt-6 lg:pt-8">
          <div className="hidden gap-8 lg:flex">
            <div className="w-8/12 text-sm leading-[18px] lg:w-4/12 lg:text-xl lg:leading-[26px]">
              {t('trendEvolution.$past')}
            </div>
            <div className="w-8/12 text-sm leading-[18px] lg:w-4/12 lg:text-xl lg:leading-[26px]">
              {t('trendEvolution.$present')}
            </div>
            <div className="w-8/12 text-sm leading-[18px] lg:w-4/12 lg:text-xl lg:leading-[26px]">
              {t('trendEvolution.$future')}
            </div>
          </div>
          <div
            className="mt-6 mb-5 hidden h-1 w-full lg:block"
            style={{ background: 'linear-gradient(270deg,rgba(76, 91, 192, 1) 30%,rgba(244, 244, 244, 1) 100%)' }}
          />

          <div className="flex items-stretch">
            <div
              className="w-1 shrink-0 self-stretch lg:hidden"
              style={{
                background: 'linear-gradient(0deg,rgba(76, 91, 192, 1) 0%,rgba(244, 244, 244, 1) 96%)',
              }}
            />
            <div className="flex flex-col items-center gap-8 lg:flex-row lg:items-start">
              <div className="flex w-10/12 flex-col lg:w-4/12">
                <p className="mb-4 text-sm leading-[18px] lg:hidden">{t('trendEvolution.$past')}</p>
                <p className="text-base leading-[22px]">{past}</p>
              </div>

              <div className="flex w-10/12 flex-col lg:w-4/12">
                <p className="mb-4 text-sm leading-[18px] lg:hidden">{t('trendEvolution.$present')}</p>
                <p className="text-base leading-[22px]">{present}</p>
              </div>

              <div className="flex w-10/12 flex-col lg:w-4/12">
                <p className="mb-4 text-sm leading-[18px] lg:hidden">{t('trendEvolution.$future')}</p>
                <p className="text-base leading-[22px]">{future}</p>
              </div>
            </div>
          </div>
        </div>
      </ReportModulHeader>
    </ModuleBase>
  );
};

export default TrendEvolutionModule;
